import { render } from "./CollectData.vue?vue&type=template&id=2df66eec&scoped=true"
import script from "./CollectData.vue?vue&type=script&lang=js"
export * from "./CollectData.vue?vue&type=script&lang=js"

import "./CollectData.vue?vue&type=style&index=0&id=2df66eec&scoped=true&lang=css"
import "./CollectData.vue?vue&type=style&index=1&id=2df66eec&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df66eec"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QHeader from 'quasar/src/components/header/QHeader.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QHeader,QTabs,QTab,QAvatar,QImg,QBtn,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QSeparator,QIcon,QTooltip,QSpace,QInput,QBadge,QSlideTransition,QChip,QRadio});qInstall(script, 'directives', {ClosePopup,Ripple});
